RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Invoices = Backbone.Collection.extend({
        initialize: function () {
            this.selectedId = null;
        },

        model: App.models.Invoice,

        url: '/api/invoices',

        selectInvoice: function (invoiceId) {
            invoiceId = invoiceId || this.selectedId;

            this.selectedId = invoiceId;

            const invoice = this.get(invoiceId) || this.at(0);
            if (invoice) {
                this.trigger('change', invoice);
            }
        }
    });
});
